import StoryRiverView from 'src/components/StoryRiverView'
import { useSelector } from 'react-redux'
import { getViewByName } from 'src/features/views/ViewsSelector'
import useViewProps from 'src/hooks/useViewProps'

const LatestResearch = () => {
  const title = 'Latest Research'
  const view = useSelector(getViewByName('latest research')) || null
  const { viewsError, viewsLoading, handleViewMoreClick } = useViewProps()

  return (
    <StoryRiverView
      view={view}
      viewsError={viewsError}
      viewsLoading={viewsLoading}
      handleViewMoreClick={() => handleViewMoreClick('home', title)}
      title={title}
      viewMore={{
        to: '/river/all-reports',
        show: true,
        handleMore: title
      }}
      includeTags={false}
      imagesLength={true}
      showActionBar={true}
      actionButtonsConfig={{
        sharedButtonsConfig: {
          align: 'right'
        }
      }}
    />
  )
}

export default LatestResearch
